import Cookies from "js-cookie";
import {
  AUTH_TOKEN_KEY as USER_TOKEN,
  AUTH_USER_INFO as USER_INFO,
} from "./token-util";          // existing util
import {
  AUTH_TOKEN_KEY as CREATOR_TOKEN,
  AUTH_USER_INFO as CREATOR_INFO,
} from "./creatorTokenUtil";       // existing util

/**
 * Marks which dashboard is active by setting a one‑byte cookie.
 * (No cookies are deleted, so single‑role flows stay intact.)
 */
const ROLE_KEY = "blitzActiveRole";

export const switchRole = (role /* "creator" | "user" */) => {
  Cookies.set(ROLE_KEY, role, { expires: 1 });
};
export const getActiveRole = () => Cookies.get(ROLE_KEY) || "user";
